import { useCallback, KeyboardEvent } from 'react';

export const usePreventSubmitOnEnter = () => {
  return useCallback((event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }, []);
};
